<script lang="ts" setup>
  import { UnsavedChangesModal } from '@/shared/ui/components'

  defineProps<{
    cancelTestId: string
    contentClass?: string
    formTestId: string
    isLoading: boolean
    isSaveDisabled: boolean
    saveTestId: string
    showUnsavedChangesModal: boolean
  }>()

  const emit = defineEmits<{
    (e: 'cancel'): void
    (e: 'save'): void
    (e: 'unsaved-confirm'): void
    (e: 'unsaved-discard'): void
    (e: 'update:showUnsavedChangesModal', value: boolean): void
  }>()
</script>

<template>
  <div
    class="flex min-h-0 flex-1 flex-col"
    :data-testid="formTestId"
  >
    <UnsavedChangesModal
      :show="showUnsavedChangesModal"
      :loading="isLoading"
      @update:show="emit('update:showUnsavedChangesModal', $event)"
      @confirm="emit('unsaved-confirm')"
      @discard="emit('unsaved-discard')"
    />

    <slot name="modals" />

    <NScrollbar class="max-h-[calc(100dvh-240px)]">
      <div class="p-6">
        <NSpin
          :show="isLoading"
          :content-class="contentClass"
        >
          <slot />
        </NSpin>
      </div>
    </NScrollbar>

    <footer class="bg-surface-bg border-border shrink-0 border-t p-6">
      <div class="flex flex-wrap items-center gap-1.5">
        <NButton
          type="primary"
          round
          class="min-w-25!"
          :data-testid="saveTestId"
          :disabled="isSaveDisabled || isLoading"
          @click="emit('save')"
        >
          {{ $t('base_save') }}
        </NButton>
        <NButton
          secondary
          round
          class="min-w-25!"
          :data-testid="cancelTestId"
          :disabled="isLoading"
          @click="emit('cancel')"
        >
          {{ $t('base_cancel') }}
        </NButton>
      </div>
    </footer>
  </div>
</template>
